<script>
import appConfig from "@/app.config";
// import ReportsHeader from "@/components/reports-header";

import moment from "moment";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // ReportsHeader,
  },
  data() {
    return {
      limit: 20,
      page: 1,
      selectedFixedAsset: null,
      fixedAssets: [],
      fixed_asset_products: [],
      accountingPeriods: [],
      accountFilter: {
        from: "",
        to: "",
      },
      filterdPeriod: "During of ",
      search: "",
      selectedId: null,
      fixedAsset: {},
      totalCredit: 0,
      totalDebit: 0,
      filteredFixedAssets: [],
      typesOptions: [],
      company_branches: [],
      filter: {
        branch: {
          id:0,
          name:'الكل',
          name_en:"All"
        },
        fixed_asset_type: {id:0,name:'الكل',name_en:'All'},
      },
      data: {
        fixed_asset_product: {
          code: null,
          id: 0,
          name: "الكل",
          name_en: "All",
          serial_no: null,
        },
      },
      branch_name_en: "",
      branch_name: "",
    };
  },
  computed: {},
  methods: {
    getBranches() {
      this.http.get("branches").then((res) => {
        if (res.status) this.company_branches = res.data;
      });
    },
    getFixedAssetTypesOptions() {
      this.http.get("fixed-assets/types").then((resp) => {
        this.typesOptions = resp.data;
      });
    },
    getFixedAssetProducts(search) {
      this.http
        .post("fixed-assets/fixed-asset-products/search/all-assets", {
          search,
          limit: this.limit,
          page: this.page,
          col: "name",
          filter: this.filter,
        })
        .then((res) => {
          this.filteredFixedAssets = [
            {
              code: null,
              id: 0,
              name: "الكل",
              name_en: "All",
              serial_no: null,
            },
          ];
          this.filteredFixedAssets.push(...res.data);
        });
    },
    showFixedAssetLabel(one) {
      return (
        (one?.code ? one?.code + " - " : "") +
        (this.$i18n.locale == "en" ? one.name_en : one.id + " - " + one.name) +
        (one.serial_no ? " - " + one.serial_no : "")
      );
    },
    selectFixedAsset() {
      const id = this.selectedFixedAsset.id;
      this.selectedId = id;
    },
    getReport() {
      // const id = this.selectedFixedAsset.split("-")[0];
      console.log("step 96 :", {
        fixed_asset_product_id: this.data.fixed_asset_product?.id,
        filter: this.filter,
      });

      this.http
        .post("fixed-assets/fixed-asset-products/report/depreciation", {
          fixed_asset_product_id: this.data.fixed_asset_product.id,
          filter: this.filter,
        })
        .then((res) => {
          if (res.status) {
            this.fixed_asset_products = res.data;
            this.totalCredit = 0;
            this.totalDebit = 0;
            if (this.filter.to && this.filter.from) {
              this.filterdPeriod = `
        ${moment(this.filter.from).format("YYYY-MM-DD")}  - 
        ${moment(this.filter.to).format("YYYY-MM-DD")}  `;
            } else if (this.filter.to)
              this.filterdPeriod = `${moment(this.filter.to).format(
                "YYYY-MM-DD"
              )}`;
            else if (this.filter.from)
              this.filterdPeriod = `${moment(this.filter.from).format(
                "YYYY-MM-DD"
              )}`;
            else this.filterdPeriod = "";
          }
        });
    },
    printReport() {
      window.print();
    },
    getAccountingPeriods() {
      this.http.get("accounting-peroids").then((resp) => {
        if (resp) {
          this.accountingPeriods = resp.data;
        }
      });
    },
  },
  created() {
    this.getAccountingPeriods();
    this.getFixedAssetTypesOptions();
    this.getBranches();
    let current_user = JSON.parse(localStorage.currentUser);
    this.branch_name = current_user.branch_name;
    this.branch_name_en = current_user.branch_name_en;
  },
};
</script>

<template>
  <div :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="form-group row mb-3">
    <form @submit.prevent="getReport()">
      <div class="p-3" style="background-color: rgb(246, 247, 248)">
        <!-- <div class="row">
          <div class="col-auto d-flex" style="align-items: flex-end">
            <div>
              <label for="" class="d-block">{{
                $t("fixed_assets.select_asset")
              }}</label>
              <AutoComplete
                v-model="selectedFixedAsset"
                :completeOnFocus="true"
                :optionLabel="showFixedAssetLabel"
                :suggestions="filteredFixedAssets"
                @complete="getFixedAssetProducts($event.query)"
                style="color: #333 !important"
              />
            </div>
            <div>
              <label for="" class="d-block"></label>
              <button
                type="button"
                style="margin-inline-start: 4px; height: 40px"
                @click="selectFixedAsset"
                class="btn btn-primary"
              >
                {{ $t("popups.select") }}
              </button>
            </div>
          </div>
         
          <div class="col d-flex" style="height: 40px">
            <div
              class="d-inline"
              style="margin-inline-start: 8px; margin-inline-end: 8px"
            >
              <label for="" class="d-block">{{ $t("popups.from") }}</label>

              <input
                v-model="accountFilter.from"
                :disabled="selectedId == null"
                type="date"
                class="form-control"
              />
            </div>
            <div class="d-inline">
              <label for="" class="d-block">{{ $t("popups.to") }}</label>

              <input
                v-model="accountFilter.to"
                :disabled="selectedId == null"
                type="date"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-auto d-flex gap-2" style="align-items: center">
            <button
              :disabled="selectedId == null"
              @click="
                $store.dispatch('utils/printElement', {
                  elementId: 'dep-report',
                  orientation: 'p',
                })
              "
              class="btn btn-success"
            >
              <i class="bx bx-printer"></i>
            </button>
            <button :disabled="selectedId == null" class="btn btn-success">
              {{ $t("popups.generate_report") }}
            </button>
          </div>
        </div> -->

        <div class="row">
        
          <div class="col-sm-10 col-md-7 col-6">
            <div class="card border border-secondary">
              <div class="card-body p-3">
                <h6 class="card-subtitle mb-2 text-muted">{{$t('fixed_assets.filtered_by')}}:</h6>
                  <div class="mb-3">
                    <label for="" class="form-label">{{
                      $t("emps.branch")
                    }}</label>
                    <select
                      v-model="filter.branch"
                      class="form-select form-select-md"
                      name=""
                      id=""
                    >
                      <option selected :value="{id:0, name:'الكل',name_en:'All'}">
                        {{ $t("fixed_assets.all") }}
                      </option>
                      <option
                        v-for="branch in company_branches"
                        :key="branch"
                        :value="branch"
                      >
                        {{
                          $i18n.locale == "en" ? branch.name_en : branch.name
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="" class="form-label">{{
                      $t("fixed_assets.type")
                    }}</label>
                    <select
                      v-model="filter.fixed_asset_type"
                      class="form-select form-select-md"
                      
                    >
                      <option selected :value="{id:0,name:'الكل',name_en:'All'}" >
                        {{ $t("fixed_assets.all") }}
                      </option>

                      <option
                        v-for="options in typesOptions"
                        :key="options"
                        :value="options"
                      >
                        {{
                          $i18n.locale == "ar"
                            ? options?.name
                            : options?.name_en
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <div>
                      <label for="" class="d-block">{{
                        $t("fixed_assets.fixed_asset")
                      }}</label>
                      <AutoComplete
                        v-model="data.fixed_asset_product"
                        :completeOnFocus="true"
                        :optionLabel="showFixedAssetLabel"
                        :suggestions="filteredFixedAssets"
                        @complete="getFixedAssetProducts($event.query)"
                        style="color: #333 !important; width: 100%"
                        :inputClass="'w-100'"
                      />
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label">{{
                      $t("fixed_assets.installation_date")
                    }}</label>
                    <div class="d-flex">
                     <input
                          type="date"
                          class="form-control"
                          :placeholder="$t('popups.from')"
                          v-model="filter.from"
                          :title="$t('popups.from')"
                        />
                      <input
                        type="date"
                        class="form-control"
                        :placeholder="$t('popups.to')"
                        v-model="filter.to"
                                                  :title="$t('popups.to')"

                      />
                    </div>
                  </div>
                    <div class="mb-2 d-flex justify-content-center gap-2">
                  <button type="submit" class="btn btn-success">
                    {{ $t("popups.generate_report") }}
                  </button>
                  <button
              :disabled="fixed_asset_products.length == 0"
              @click="
                $store.dispatch('utils/printElement', {
                  elementId: 'dep-report',
                  orientation: 'p',
                })
              "
              class="btn btn-success"
            >
              <i class="bx bx-printer"></i>
            </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4" id="dep-report" v-if="fixed_asset_products.length > 0">
    <div class="card card-body">
      <!-- <ReportsHeader
        :reportName="

          $t('fixed_assets.depreciation_report')
        "
        
        :filterdPeriod="
          filterdPeriod && $i18n.locale == 'ar'
            ? 'خلال  ' + filterdPeriod
            : filterdPeriod
            ? 'During of ' + filterdPeriod
            : ' - '
        "
      /> -->

      <div class="report-header" data-v-b43e28ca="">
        <div class="row justify-content-center">
          <div class="col-10 text-center">
            <h5>
              {{ $i18n.locale == "ar" ? "هيئة المياه فرع " : "KSWC" }} -
              {{ $i18n.locale == "ar" ? branch_name : branch_name_en }}
            </h5>
            <h5 class="text-decoration-underline">
              {{ $t("fixed_assets.depreciation_report") }}
            </h5>
            <h5 v-if="filterdPeriod">
              {{ $t("fixed_assets.installation_date") }}
              <span> {{ filterdPeriod }}</span>
            </h5>
          </div>
          <div class="col-2">
              <h6>{{ $t("emps.branch")}} : <span v-if="filter.branch">{{ $i18n.locale == 'en' ? filter.branch?.name_en :  filter.branch?.name}}</span></h6>
              <h6>{{ $t("fixed_assets.type")}} : <span v-if="filter.fixed_asset_type ">{{ $i18n.locale == 'en' ? filter.fixed_asset_type?.name_en :  filter.fixed_asset_type?.name}}</span></h6>
              <h6>{{ $t("fixed_assets.fixed_asset")}} : <span v-if="data.fixed_asset_product ">{{ (data.fixed_asset_product?.code?  data.fixed_asset_product?.code + ' - ':'') +  ($i18n.locale == 'en' ? data.fixed_asset_product?.name_en :  data.fixed_asset_product?.name)+(data.fixed_asset_product.serial_no? '-'+data.fixed_asset_product.serial_no :'')}}</span></h6>
          </div>
        </div>
      </div>
      <div class="table-responsive p-3">
        <table
          class="table table-centered table-nowrap table-striped table-hover align-middle"
          :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
        >
          <thead>
            <tr class="text-light" style="background-color: #2a3042 !important">
              <!-- <th scope="col">{{ $t("general_ledger.account_id") }}</th> -->
              <th scope="col">{{ $t("fixed_assets.code") }}</th>
              <th scope="col">{{ $t("fixed_assets.fixed_asset") }}</th>
              <th class="col">{{ $t("fixed_assets.serial_no") }}</th>
              <th scope="col">{{ $t("fixed_assets.category") }}</th>
              <th class="col">{{ $t("fixed_assets.initial") }}</th>
              <th class="col">{{ $t("fixed_assets.installation_date") }}</th>
              <th class="col">{{ $t("fixed_assets.current_depreciation") }}</th>
              <th class="col">
                {{ $t("fixed_assets.accumulated_depreciation") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="" v-for="product in fixed_asset_products" :key="product">
              <td>{{ product.code }}</td>
              <td>
                {{ $i18n.locale == "ar" ? product?.name : product?.name_en }}
              </td>
              <td>{{ product.serial_no }}</td>
              <td>
                {{
                  $i18n.locale == "ar"
                    ? product?.fixed_asset_type_name
                    : product?.fixed_asset_type_name_en
                }}
              </td>
              <td>
                {{ parseFloat(product?.initial_book_value).toLocaleString() }}
              </td>
              <td>{{ product?.installation_date }}</td>
              <td>
                {{ parseFloat(product?.current_depreciation).toLocaleString() }}
              </td>
              <td>
                {{
                  parseFloat(product?.accumulated_depreciation).toLocaleString()
                }}
              </td>

              <td></td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <th>{{ $t("reports.report_date") }} :</th>
            <th>
              {{ moment().format("YYYY-MM-DD hh:mm:ss A") }}
            </th>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.print {
  display: none;
}

@media print {
  .no-print {
    display: none;
  }

  .print {
    display: block;
  }
}

/*
.table,
td {
  border: 1px solid black;
}
*/
</style>
